import { TipoNotificacaoEnum } from "../../enums/tipo-notificacao-enum";

export class LoteNotificacaoSmsPK {

    numLote: number = 0;

    tipoNotificacao: TipoNotificacaoEnum = TipoNotificacaoEnum.CAN;

    dataNotificacao: Date = new Date();

    constructor() {
    }
}
